export default __webpack_public_path__ + "static/media/alETH.2f8fdd3c.svg";